(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8738:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(70650);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 68461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Item": function() { return /* binding */ Item; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39097);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1098);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52823);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15567);
/* harmony import */ var _utils_index_config__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67453);







var Item = function(param) {
    var data = param.data;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
        href: data.href,
        passHref: true,
        prefetch: false,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
            className: "cursor-pointer",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "hidden md:block",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .C, {
                        layout: "responsive",
                        src: data.image,
                        alt: data.title,
                        width: 2560,
                        height: 893
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "md:hidden",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .C, {
                        layout: "responsive",
                        src: data.mobileImage,
                        width: 528,
                        height: 704,
                        alt: data.title
                    })
                }),
                ' '
            ]
        })
    }, data.href);
};
var IndexSwiper = function() {
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .Swiper */ .t, {
        modules: [
            swiper__WEBPACK_IMPORTED_MODULE_3__/* .Autoplay */ .pt,
            swiper__WEBPACK_IMPORTED_MODULE_3__/* .Mousewheel */ .Gk,
            swiper__WEBPACK_IMPORTED_MODULE_3__/* .Navigation */ .W_
        ],
        autoplay: true,
        loop: true,
        children: _utils_index_config__WEBPACK_IMPORTED_MODULE_6__/* .BANNERS.map */ .hx.map(function(i) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .SwiperSlide */ .o, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Item, {
                    data: i
                })
            }, i.title);
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (IndexSwiper);


/***/ }),

/***/ 70650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
// EXTERNAL MODULE: ../../node_modules/next/script.js
var script = __webpack_require__(45847);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ../../node_modules/swiper/swiper.esm.js + 89 modules
var swiper_esm = __webpack_require__(1098);
// EXTERNAL MODULE: ../../node_modules/swiper/react/swiper-react.js + 12 modules
var swiper_react = __webpack_require__(52823);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
// EXTERNAL MODULE: ../../node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(65186);
// EXTERNAL MODULE: ../../node_modules/react-stickynode/dist/es/Sticky.js + 11 modules
var Sticky = __webpack_require__(36977);
// EXTERNAL MODULE: ./src/components/Image.tsx
var components_Image = __webpack_require__(15567);
// EXTERNAL MODULE: ./src/utils/index-config.ts
var index_config = __webpack_require__(67453);
// EXTERNAL MODULE: ./src/components/Container.tsx
var components_Container = __webpack_require__(98159);
// EXTERNAL MODULE: ./src/components/Product.tsx + 1 modules
var components_Product = __webpack_require__(15318);
// EXTERNAL MODULE: ../../node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(84988);
// EXTERNAL MODULE: ./src/utils/helpers.ts
var helpers = __webpack_require__(37336);
// EXTERNAL MODULE: ./src/components/Layout/layout.tsx + 18 modules
var layout = __webpack_require__(53808);
;// CONCATENATED MODULE: ./src/components/index-section.tsx





// import dynamic from 'next/dynamic'





// import { imageLoader } from '../utils/helpers'





var homePageSensorMod = function() {
    return __webpack_require__.e(/* import() */ 494).then(__webpack_require__.bind(__webpack_require__, 43494));
};
var homePageSensor;
var sizeLists = [
    {
        label: '12 / L',
        handle: '12xl'
    },
    {
        label: '14 / 1X',
        handle: '14-1x-1'
    },
    {
        label: '16 / 1X',
        handle: '16-1x-1'
    },
    {
        label: '18 / 2X',
        handle: '18-2x-1'
    },
    {
        label: '20 / 2X',
        handle: '20-2x-1'
    },
    {
        label: '22 / 3X',
        handle: '22-3x-1'
    }, 
];
/**
 * Index Components
 */ var SectionHeader = function(props) {
    var children = props.children, className = props.className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
        className: classnames_default()([
            'md:text-3xl text-lg font-medium text-center',
            className, 
        ]),
        children: children
    }));
};
var SectionOne = function() {
    /*#__PURE__*/ return _jsxs("section", {
        className: "lg:container flex items-center text-center text-xl whitespace-nowrap",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "p-11 flex-1",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "tracking-widest font-light",
                        children: "UP TO"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "text-7xl font-semibold my-1",
                        children: [
                            "15",
                            /*#__PURE__*/ _jsx("sup", {
                                className: "text-4.5xl tracking-normal",
                                children: "%"
                            }),
                            /*#__PURE__*/ _jsx("small", {
                                className: "text-lg uppercase -ml-9",
                                children: "off"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "tracking-widest font-light",
                        children: "SUMMER SALE"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Image, {
                src: "/images/section1-1.jpeg",
                width: 750,
                height: 1000,
                alt: "summer sale"
            }),
            /*#__PURE__*/ _jsx(Image, {
                src: "/images/section1-2.jpeg",
                width: 750,
                height: 1000,
                alt: "summer sale"
            })
        ]
    });
};
var SectionTwo = function() {
    var renderContent = function(param) {
        var prefix = param.prefix, surffix = param.surffix, title = param.title, buttons = param.buttons;
        /*#__PURE__*/ return _jsxs("div", {
            className: "absolute top-0 bottom-0 w-full z-10 bg-black bg-opacity-15 text-white flex flex-col justify-center items-center",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "font-light tracking-wider text-sm",
                    children: prefix
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "text-3xl font-semibold my-2",
                    children: title
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "font-light text-sm",
                    children: surffix
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "mt-3",
                    children: buttons.map(function(i, idx) {
                        /*#__PURE__*/ return _jsx("a", {
                            className: "button button--outline text-sm mx-1",
                            href: i.href,
                            children: i.label
                        }, idx);
                    })
                })
            ]
        });
    };
    return(/*#__PURE__*/ _jsx("section", {
        className: "container leading-0",
        children: /*#__PURE__*/ _jsx("div", {
            className: "flex -mx-2.5",
            children: SECTION_TWO.map(function(i) {
                /*#__PURE__*/ return _jsx("div", {
                    className: "px-2.5",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ _jsx(Image, {
                                src: i.image,
                                width: 1268,
                                height: 972,
                                alt: "new arrival"
                            }),
                            renderContent(i)
                        ]
                    })
                }, i.image);
            })
        })
    }));
};
var CategoryList = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(components_Container/* default */.Z, {
        className: "mt-6 md:mt-16 md:mb-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader, {
                className: "mb-1.5 md:mb-9",
                children: "Shop By Category"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid md:grid-cols-6 grid-cols-2 -mx-1.5 md:-mx-2.5",
                children: index_config/* SECTION_THREE.map */.b2.map(function(i) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_link["default"], {
                        href: "/collections/".concat(i.title),
                        passHref: true,
                        prefetch: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "py-3.5 px-2 md:p-2.5 inline-flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Image/* default */.C, {
                                src: i.image,
                                alt: i.title,
                                width: 320,
                                height: 400
                            })
                        })
                    }, i.title);
                })
            })
        ]
    });
};
var SectionFour = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(components_Container/* default */.Z, {
        className: "mt-3 md:mt-14",
        children: index_config/* SECTION_FOUR.map */.X4.map(function(i) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_link["default"], {
                href: "/collections/".concat(i.title),
                passHref: true,
                prefetch: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: "block md:mb-8 mb-2.5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hidden md:block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Image/* default */.C, {
                                layout: "responsive",
                                src: i.image,
                                alt: i.title,
                                width: 1400,
                                height: 700
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "md:hidden",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Image/* default */.C, {
                                layout: "responsive",
                                src: i.mobileImage,
                                width: 720,
                                height: 864,
                                alt: i.title
                            })
                        }),
                        ' '
                    ]
                })
            }, i.title);
        })
    });
};
var SectionFive = function() {
    /*#__PURE__*/ return _jsx(Container, {
        className: "mt-10 md:mt-10",
        children: /*#__PURE__*/ _jsx("div", {
            className: "grid grid-cols-none md:grid-cols-3 -mx-3",
            children: Array(3).fill(0).map(function(_, idx) {
                /*#__PURE__*/ return _jsx("div", {
                    className: "px-3 mb-4 md:mb-0",
                    children: /*#__PURE__*/ _jsx(Image, {
                        src: "/images/section4-1.jpeg",
                        width: 600,
                        height: 800,
                        alt: "party"
                    })
                }, idx);
            })
        })
    });
};
var OccasionList = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(components_Container/* default */.Z, {
        className: "mt-6 md:mt-16 -mb-1.5 md:mb-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader, {
                className: "mb-1.5 md:mb-9",
                children: "Shop By Occasion"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid md:grid-cols-4 grid-cols-2 -mx-1.5 md:-mx-2.5",
                children: index_config/* SECTION_FIVE.map */.aI.map(function(i) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_link["default"], {
                        href: "/collections/".concat(i.title),
                        passHref: true,
                        prefetch: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "py-3.5 px-2 md:p-2.5 inline-flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Image/* default */.C, {
                                src: i.image,
                                alt: i.title,
                                width: 320,
                                height: 464
                            })
                        })
                    }, i.title);
                })
            })
        ]
    });
};
var SizeSection = function(props) {
    var title = props.title;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Container/* default */.Z, {
        className: "mt-4 md:mt-14",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader, {
                className: "mb-5 md:mb-8",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-3 md:grid-cols-6 gap-x-3 md:gap-x-4 gap-y-3 md:gap-y-4",
                children: sizeLists.map(function(i) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_link["default"], {
                        href: "/collections/".concat(i.handle),
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "button bg-white text-black text-xs sm:text-sm md:text-lg text-center py-2 sm:py-3 md:py-4 px-0 border border-black",
                            children: i.label
                        })
                    }, i.label);
                })
            })
        ]
    }));
};
// export const SectionSix = () => (
//   <section>
//     <div className="relative overflow-hidden" style={{ height: '650px' }}>
//       <div className="flex justify-center items-center h-full">
//         <div>
//           <Image
//             src={imageLoader('/images/section5-1.jpeg')}
//             alt="new fashion"
//             layout="fill"
//             objectFit="cover"
//           />
//         </div>
//       </div>
//       <div className="absolute top-0 bottom-0 w-full z-10">
//         <div className="container text-white flex items-center h-full">
//           <div className="relative hero__text-shadow">
//             <div className="text-7xl font-semibold">NEW FASHION</div>
//             <div className="text-lg">explore now</div>
//           </div>
//         </div>
//       </div>
//     </div>
//     <div className="text-center mt-10">
//       <Link href="/">
//         <a className="button bg-black text-white text-sm py-3">VIEW ALL</a>
//       </Link>
//     </div>
//   </section>
// )
var ProductSection = function(props) {
    var ref3, ref1, ref2;
    var data = props.data, title = props.title;
    return(/*#__PURE__*/ _jsxs(Container, {
        className: "mt-10 md:mt-12",
        children: [
            /*#__PURE__*/ _jsx(Link, {
                href: "/collections/".concat(data === null || data === void 0 ? void 0 : (ref3 = data.collection) === null || ref3 === void 0 ? void 0 : ref3.handle),
                passHref: true,
                prefetch: false,
                children: /*#__PURE__*/ _jsx("a", {
                    children: /*#__PURE__*/ _jsx(SectionHeader, {
                        className: "mb-4 md:mb-8",
                        children: title
                    })
                })
            }),
            data && /*#__PURE__*/ _jsx("div", {
                className: "grid grid-cols-2 md:grid-cols-5 gap-x-3 md:gap-x-4",
                children: (ref1 = data.collection) === null || ref1 === void 0 ? void 0 : ref1.products.edges.slice(0, 10).map(function(i, index) {
                    var ref;
                    return(/*#__PURE__*/ _jsx(Product, {
                        className: "mb-6",
                        collectionTitle: ((ref = data.collection) === null || ref === void 0 ? void 0 : ref.title) || '',
                        data: i.node,
                        productIndex: index + 1,
                        hiddenRating: true
                    }, i.node.id));
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "text-center mt-4",
                children: /*#__PURE__*/ _jsx(Link, {
                    href: "/collections/".concat(data === null || data === void 0 ? void 0 : (ref2 = data.collection) === null || ref2 === void 0 ? void 0 : ref2.handle),
                    passHref: true,
                    prefetch: false,
                    children: /*#__PURE__*/ _jsx("a", {
                        className: "button text-white bg-black text-tiny sm:text-sm md:py-3 md:px-6 font-semibold tracking-normal tracking-widest",
                        children: "VIEW ALL"
                    })
                })
            })
        ]
    }));
};
var InfinityCardsMobileSection = function(props) {
    var ref8, ref4, ref5, ref6;
    var data = props.data;
    var total = ((ref4 = data === null || data === void 0 ? void 0 : (ref8 = data.collection) === null || ref8 === void 0 ? void 0 : ref8.products.edges) === null || ref4 === void 0 ? void 0 : ref4.length) || 0;
    var ref7 = (0,react.useState)(1), page = ref7[0], setPage = ref7[1];
    var fetchMore = function() {
        setPage(page + 1);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Container/* default */.Z, {
        className: "mt-2",
        children: [
            data && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-2 gap-x-3",
                children: (ref5 = data.collection) === null || ref5 === void 0 ? void 0 : ref5.products.edges.slice(0, 10 * page).map(function(i, index) {
                    var ref;
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_Product/* default */.Z, {
                        className: "mb-6",
                        collectionTitle: ((ref = data.collection) === null || ref === void 0 ? void 0 : ref.title) || '',
                        data: i.node,
                        productIndex: index + 1,
                        hiddenRating: true
                    }, i.node.id));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center",
                children: page > 3 || total <= page * 10 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: "/collections/".concat(data === null || data === void 0 ? void 0 : (ref6 = data.collection) === null || ref6 === void 0 ? void 0 : ref6.handle),
                    passHref: true,
                    prefetch: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "button text-white bg-black text-tiny sm:text-sm md:py-3 md:px-6 font-semibold tracking-normal tracking-widest",
                        children: "VIEW ALL"
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "absolute bottom-0 left-0 w-full flex justify-center items-center pt-7 pb-2 text-center text-xss cursor-pointer",
                    style: {
                        backgroundImage: 'linear-gradient(0deg,rgba(255, 255, 255, 1) 0%,rgba(255, 255, 255, 1) 60%,rgba(255, 255, 255, 0) 100%)'
                    },
                    onClick: function() {
                        return fetchMore();
                    },
                    children: [
                        "Load More",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdOutlineKeyboardArrowDown */.x3N, {
                            color: "inherit",
                            size: 18
                        })
                    ]
                })
            })
        ]
    }));
};
var ProductScrollXSection = function(props) {
    var ref11, ref9, ref10;
    var data = props.data, title = props.title;
    var randomText = '';
    for(var i1 = 0; i1 < 10; i1 += 1){
        randomText += String.fromCharCode(Math.floor(Math.random() * 26 + 65));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Container/* default */.Z, {
        className: "relative mt-10 md:mt-24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between text-center mt-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: "/collections/".concat(data === null || data === void 0 ? void 0 : (ref11 = data.collection) === null || ref11 === void 0 ? void 0 : ref11.handle),
                        passHref: true,
                        prefetch: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader, {
                                className: "mb-4 md:mb-8 md:text-3xl",
                                children: title
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: "/collections/".concat(data === null || data === void 0 ? void 0 : (ref9 = data.collection) === null || ref9 === void 0 ? void 0 : ref9.handle),
                        passHref: true,
                        prefetch: false,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "text-black text-tiny sm:text-lg md:py-3 md:px-6 font-semibold tracking-normal underline",
                            children: "View More"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "absolute left-0 right-0",
                        style: {
                            paddingTop: 'calc((100% - (16 * 4px)) / 5 * 4 / 3 / 2 )'
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                className: "".concat(randomText, "-swiper-btn-prev absolute left-0 z-10 transform -translate-y-1/2 -translate-x-1/2 border-1 border-gray-400 hover:border-black border-solid rounded-full w-11 h-11 flex justify-center items-center text-gray-400 hover:text-black bg-white hover:bg-gray-50"),
                                style: {
                                    top: "100%"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdOutlineArrowBackIos */.oTp, {
                                    color: "inherit",
                                    fontSize: "18"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                type: "button",
                                className: "".concat(randomText, "-swiper-btn-next absolute right-0 z-10 transform -translate-y-1/2 translate-x-1/2 border-1 border-gray-400 hover:border-black border-solid rounded-full w-11 h-11 flex justify-center items-center text-gray-400 hover:text-black bg-white hover:bg-gray-50"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* MdOutlineArrowForwardIos */.Djl, {
                                    color: "inherit",
                                    fontSize: "18"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.t, {
                        modules: [
                            swiper_esm/* Mousewheel */.Gk,
                            swiper_esm/* Navigation */.W_
                        ],
                        slidesPerView: 5,
                        spaceBetween: 16,
                        slidesPerGroup: 5,
                        loop: true,
                        loopFillGroupWithBlank: true,
                        pagination: {
                            clickable: true
                        },
                        navigation: {
                            prevEl: ".".concat(randomText, "-swiper-btn-prev"),
                            nextEl: ".".concat(randomText, "-swiper-btn-next")
                        },
                        direction: "horizontal",
                        mousewheel: {
                            forceToAxis: true
                        },
                        className: "mySwiper",
                        threshold: 100,
                        children: data && ((ref10 = data.collection) === null || ref10 === void 0 ? void 0 : ref10.products.edges.slice(0, 20).map(function(i, index) {
                            var ref;
                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o, {
                                style: {
                                    padding: '0 0.5px'
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Product/* default */.Z, {
                                    className: "mb-6",
                                    collectionTitle: ((ref = data.collection) === null || ref === void 0 ? void 0 : ref.title) || '',
                                    data: i.node,
                                    productIndex: index + 1,
                                    hiddenRating: true,
                                    moduleName: title.toLowerCase().replace(/^./, title[0].toUpperCase())
                                }, i.node.id)
                            }, index));
                        }))
                    })
                ]
            })
        ]
    }));
};
var ProductCategorySection = function(props) {
    var data = props.data, swiperArr = props.swiperArr;
    var showDiscount = (0,react.useContext)(layout/* ShowDiscount */.R);
    var ref15 = (0,react.useState)(null), swiper = ref15[0], setSwiper = ref15[1];
    var ref12 = (0,react.useState)(0), swiperActive = ref12[0], setSwiperActive = ref12[1];
    var slideTo = function(index) {
        var ref, ref13, ref14;
        setSwiperActive(index);
        // @ts-ignore
        swiper.slideTo(index);
        if ((((ref13 = (ref = document === null || document === void 0 ? void 0 : document.querySelector('#home-tabs-wrapper')) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect()) === null || ref13 === void 0 ? void 0 : ref13.top) || 0) > 0) return;
        (ref14 = document.querySelector('#home-tabs-wrapper')) === null || ref14 === void 0 ? void 0 : ref14.scrollIntoView();
    };
    (0,helpers/* useIsomorphicLayoutEffect */.LI)(function() {
        if (true) {
            homePageSensorMod().then(function(mod) {
                homePageSensor = mod.default;
            });
        }
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-white pt-7 relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "home-tabs-wrapper",
                className: "absolute -top-16"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Sticky/* default */.Z, {
                innerClass: "z-20",
                top: showDiscount ? 88 : 0,
                bottomBoundary: ".home-sticky-end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid grid-cols-4 gap-x-3 md:gap-x-4 gap-y-3 md:gap-y-4 py-0.5 bg-white",
                    children: swiperArr.map(function(i, k) {
                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: function() {
                                slideTo(k);
                                homePageSensor === null || homePageSensor === void 0 ? void 0 : homePageSensor.ResourcesShow(document.getElementsByTagName('section'), false);
                            },
                            className: "flex justify-center bg-white text-black text-xss text-center py-1 sm:py-2 px-0 leading-relaxed cursor-pointer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "transform translate-y-1.5 pb-2 border-black ".concat(swiperActive === k && 'font-bold border-b-2'),
                                children: i.label
                            })
                        }, "size-".concat(i.label)));
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.t, {
                // @ts-ignore
                onSwiper: setSwiper,
                onSlideChangeTransitionEnd: function(e) {
                    return setSwiperActive(e.activeIndex);
                },
                className: "home-tabs-container",
                children: swiperArr.map(function(i, k) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            "data-name": i.label,
                            "data-id": "SwiperSlide-".concat(i.label),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfinityCardsMobileSection, {
                                data: data["handle".concat(k)]
                            })
                        })
                    }, i.label);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "home-sticky-end"
            })
        ]
    }));
};
var AboutUs = function() {
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(components_Container/* default */.Z, {
        className: "mt-10 md:mt-24",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "md:flex md:items-center 2xl:px-32",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hidden md:block text-center mr-16 md:mr-8 mb-2 md:mb-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Image/* default */.C, {
                        src: "//cdn.shopifycdn.net/s/files/1/0510/7171/3450/files/3_e3a2af07-b256-4391-9adc-b26e0d93f4af.jpg?v=1625491354",
                        width: "500",
                        height: "261",
                        alt: "about bloomchic"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-left sm:text-center md:text-left w-full sm:w-126 mx-auto",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            className: "text-15 font-semibold mt-4 mb-2 md:mb-3",
                            children: "About Us"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-13 md:text-15 mb-6 lg:leading-relaxed",
                            children: "At BloomChic, we believe that all women deserve to look and feel absolutely beautiful. We're striving to bring the most on-trend and stylish pieces in sizes 12-20, and we're reimagining this space and creating a customer-centric shopping destination that always puts fashion first."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            href: "/blogs/new1/press",
                            prefetch: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "block md:hidden text-center md:mr-14 lg:mr-28 mb-2 md:mb-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Image/* default */.C, {
                                            src: "//cdn.shopifycdn.net/s/files/1/0510/7171/3450/files/logo1.jpg?v=1635861490",
                                            width: "1600",
                                            height: "125",
                                            alt: "about bloomchic"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "hidden md:inline-block button text-white bg-black text-tiny sm:text-sm md:py-3 md:px-6 font-semibold tracking-widest",
                                        children: "LEARN MORE"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var CovetPics = function() {
    /*#__PURE__*/ return _jsxs("div", {
        className: "mt-10 md:mt-24",
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: "text-md md:text-3xl font-semibold text-center mb-8",
                children: "SHOP OUR INSTAGRAM"
            }),
            /*#__PURE__*/ _jsx("h4", {
                className: "text-center italic mb-10 md:text-lg font-normal",
                children: "Click on an image to shop products"
            }),
            /*#__PURE__*/ _jsx("covet-pics-widget", {
                "gallery-embed-id": "182934"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/swipers/IndexSwiper.tsx
var IndexSwiper = __webpack_require__(68461);
;// CONCATENATED MODULE: ./src/pages/index.tsx

/* eslint-disable react-hooks/exhaustive-deps */ 



// import Image from '../components/Image'
// import { useCollectionQuery } from '../hooks/useCollections'


// import router from 'next/router'




function _objectWithoutProperties(source, excluded) {
    if (source == null) return {
    };
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {
    };
    var target = {
    };
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// import InfinityCards from '../components/InfinityCards'
// import Layout from '../components/Layout/layout'
var pages_IndexSwiper = (0,dynamic["default"])(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 68461));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68461)
            ];
        },
        modules: [
            "index.tsx -> " + "../components/swipers/IndexSwiper"
        ]
    },
    ssr: false,
    loading: function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(IndexSwiper.Item, {
            data: index_config/* BANNERS.0 */.hx[0]
        });
    }
});
var swiperArr = [
    {
        label: 'New',
        handle: 'new-in-1'
    },
    {
        label: 'Best Sellers',
        handle: 'best-sellers-1'
    },
    {
        label: 'Dresses',
        handle: 'dresses-1'
    },
    {
        label: 'Outerwear',
        handle: 'coats-jackets-1'
    }, 
];
var pages_homePageSensorMod = function() {
    return __webpack_require__.e(/* import() */ 494).then(__webpack_require__.bind(__webpack_require__, 43494));
};
var pages_homePageSensor;
var Index = function(props) {
    var description = props.description, title = props.title, data = _objectWithoutProperties(props, [
        "description",
        "title"
    ]);
    // const data = { newIn, holidaySale, bestSell, classy }
    (0,helpers/* useIsomorphicLayoutEffect */.LI)(function() {
        if (true) {
            pages_homePageSensorMod().then(function(mod) {
                pages_homePageSensor = mod.default;
                pages_homePageSensor === null || pages_homePageSensor === void 0 ? void 0 : pages_homePageSensor.Action();
            });
        }
    }, []);
    var theme = (0,useTheme/* default */.Z)();
    var upMd = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up('md'));
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pb-5 md:pb-36",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: index_config/* BANNERS.0.image */.hx[0].image
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:width",
                        content: "1200"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image:height",
                        content: "627"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:site",
                        content: "@"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(script["default"], {
                strategy: "lazyOnload",
                src: "https://shopify.covet.pics/covet-pics-widget-inject.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                "data-name": "顶部轮播图",
                "data-id": "20211008-IndexSwiper-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_IndexSwiper, {
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                "data-name": "分类区",
                "data-id": "20211008-CategoryList-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryList, {
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                "data-name": "four-image",
                "data-id": "20211008-SectionFour-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionFour, {
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                "data-name": "分类区",
                "data-id": "20211222-OccasionList-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OccasionList, {
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                "data-name": "SHOP BY SIZE",
                "data-id": "20211113-ShopBySize-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SizeSection, {
                    title: "Shop By Size"
                })
            }),
            upMd ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        "data-name": "JUST DROPPED",
                        "data-id": "20211110-Collection-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductScrollXSection, {
                            data: data === null || data === void 0 ? void 0 : data.handle0,
                            title: "Just Dropped"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        "data-name": "BEST SELLERS",
                        "data-id": "20211110-Collection-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductScrollXSection, {
                            data: data === null || data === void 0 ? void 0 : data.handle1,
                            title: "Best Sellers"
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCategorySection, {
                data: data,
                swiperArr: swiperArr
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                "data-name": "品牌介绍区",
                "data-id": "20211008-AboutUs-1",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUs, {
                })
            })
        ]
    }));
};
var __N_SSG = true;
// @ts-ignore
// Index.getLayout = function getLayout(page) {
//   return <Layout showDiscount>{page}</Layout>
// }
/* harmony default export */ var pages = (Index);


/***/ }),

/***/ 67453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hx": function() { return /* binding */ BANNERS; },
/* harmony export */   "b2": function() { return /* binding */ SECTION_THREE; },
/* harmony export */   "X4": function() { return /* binding */ SECTION_FOUR; },
/* harmony export */   "aI": function() { return /* binding */ SECTION_FIVE; }
/* harmony export */ });
/* unused harmony export SECTION_TWO */
var BANNERS = [
    {
        image: 'https://cdn.shopifycdn.net/s/files/1/0510/7171/3450/files/1920X670_3854a059-990d-4cc2-bc87-c5756fcdf695.jpg?v=1639647286',
        mobileImage: 'https://cdn.shopifycdn.net/s/files/1/0510/7171/3450/files/750X1000_a45ed532-57ae-42b2-8f44-854d147b3fe3.jpg?v=1639647299',
        title: 'banner1',
        href: '/collections/holiday-sale'
    },
    {
        image: 'https://cdn.shopifycdn.net/s/files/1/0510/7171/3450/files/e6c50fccc8ba83035c87a3af2f9670b9_5830d418-3e01-44ca-9849-bb8b623b1226.jpg?v=1638787918',
        mobileImage: 'https://cdn.shopifycdn.net/s/files/1/0510/7171/3450/files/782x712_d9a09233-d8dd-42f3-adab-2665a3cd8559.jpg?v=1638787937',
        title: 'banner2',
        href: '/collections/velvet-2'
    }, 
];
var SECTION_TWO = [
    {
        image: 'https://cdn.shopifycdn.net/s/files/1/0510/7171/3450/collections/2021-3-3_4__02.jpg?v=1629706716',
        prefix: 'SUMMER FASHION',
        surffix: 'Update the new and upcoming trends',
        title: 'NEW ARRIVAL',
        buttons: [
            {
                label: 'TOPS',
                href: '/collections/tops'
            },
            {
                label: 'BOTTOMS',
                href: '/collections/tops'
            }, 
        ]
    }, 
];
// export const SECTION_THREE = [
//   'dresses-1',
//   'tops-1',
//   'sweatshirts',
//   'bottoms-1',
//   'romper-jumpsuit',
//   'sweaters-cardigans-1',
//   'accessories',
//   'lingerie-loungwear',
// ].map((i, idx) => ({
//   image: imageLoader(`/images/section3-${idx + 1}.jpeg`),
//   title: i,
// }))
var SECTION_THREE = [
    {
        image: 'https://cdn.shopify.com/s/files/1/0510/7171/3450/collections/2021-3-3_4__02.jpg?v=1640080984',
        title: 'dresses-1'
    },
    {
        image: 'https://cdn.shopify.com/s/files/1/0510/7171/3450/collections/2021-3-3_4__01.jpg?v=1640080985',
        title: 'tops-1'
    },
    {
        image: 'https://cdn.shopify.com/s/files/1/0510/7171/3450/collections/2021-3-3_4__03.jpg?v=1640080987',
        title: 'bottoms-1'
    },
    {
        image: 'https://cdn.shopify.com/s/files/1/0510/7171/3450/collections/436-160_25_3496e864-ca97-4651-891a-9b4c862e81ca.jpg?v=1640080966',
        title: 'coats-jackets-1'
    },
    {
        image: 'https://cdn.shopify.com/s/files/1/0510/7171/3450/collections/Shop-By-Category320X320_06.jpg?v=1640080842',
        title: 'loungewear'
    },
    {
        image: 'https://cdn.shopify.com/s/files/1/0510/7171/3450/collections/Shop-By-Category320X320_05.jpg?v=1640080872',
        title: 'sweaters-cardigans'
    }, 
];
var SECTION_FOUR = [
    {
        image: 'https://cdn.shopify.com/s/files/1/0510/7171/3450/files/1400X700_06.jpg?v=1640076218',
        mobileImage: 'https://cdn.shopify.com/s/files/1/0510/7171/3450/files/670X804.jpg?v=1640076218',
        title: 'up-to-70-off'
    },
    {
        image: 'https://cdn.shopify.com/s/files/1/0510/7171/3450/files/1400X700_04.jpg?v=1640076218',
        mobileImage: 'https://cdn.shopify.com/s/files/1/0510/7171/3450/files/750X900_4a6e2f20-f8e6-44d9-a89b-50bf59f82d39.jpg?v=1640076218',
        title: 'velvet-2'
    },
    {
        image: 'https://cdn.shopifycdn.net/s/files/1/0510/7171/3450/files/1400X700_05.jpg?v=1640076218',
        mobileImage: 'https://cdn.shopifycdn.net/s/files/1/0510/7171/3450/files/670X804_173741ff-b0f4-47e7-9221-7c5ba515ec5d.jpg?v=1640076218',
        title: 'loungewear'
    }, 
];
var SECTION_FIVE = [
    {
        image: 'https://cdn.shopifycdn.net/s/files/1/0510/7171/3450/collections/Shop-by-trend_516x690_01.jpg?v=1640081554',
        title: 'going-out'
    },
    {
        image: 'https://cdn.shopifycdn.net/s/files/1/0510/7171/3450/collections/Shop-by-trend_516x690_03.jpg?v=1640081588',
        title: 'party-2'
    },
    {
        image: 'https://cdn.shopifycdn.net/s/files/1/0510/7171/3450/collections/Shop-by-trend_516x690_02.jpg?v=1640081529',
        title: 'business-1'
    },
    {
        image: 'https://cdn.shopifycdn.net/s/files/1/0510/7171/3450/collections/Shop-by-trend_516x690_04.jpg?v=1640081576',
        title: 'vacation-1'
    }, 
];


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [424,774,888,179], function() { return __webpack_exec__(8738); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);